<template>
  <b-row
    v-show="isInManagement == false"
    v-if="parentPath && path"
    style="height:100%;margin-bottom:55px"
  >
    <b-col md="12">
      <b-card
        v-tooltip="uniToolTipTranslation('S654', 'en-US')"
        style="margin-bottom:0px;"
        class="card-panel"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
      >
        <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
          {{ uniTranslation("TRNSL36") }}
        </div>
        <div class="row">
          <div class="col-xl-12 col-lg-12">
            <button
              v-tooltip="{
                content: uniToolTipTranslation('TRNSL37', 'en-US'),
                placement: 'top'
              }"
              :style="{
                backgroundColor: coloreFooterBottoniSelection,
                borderColor: coloreBordoBottoniSelection,
                color: coloreTestoBottoniSelection,
                width: '48%'
              }"
              type="button"
              class="btn btn-default"
              @click="setSelection"
            >
              <i class="fa-solid fa-table-list"></i>
              {{ uniTranslation("TRNSL37") }}
            </button>
            <button
              v-tooltip="{
                content: uniToolTipTranslation('TRNSL38', 'en-US'),
                placement: 'top'
              }"
              :style="{
                backgroundColor: coloreFooterBottoniVerify,
                borderColor: coloreBordoBottoniVerify,
                color: coloreTestoBottoniVerify,
                width: '48%'
              }"
              type="button"
              class="btn btn-default"
              @click="setVerify"
            >
              <i class="fa-solid fa-location-crosshairs"></i>
              {{ uniTranslation("TRNSL38") }}
            </button>
          </div>
        </div>
        <div v-if="inVerifica" class="row">
          <div class="col-xl-12 col-lg-12">
            <label v-tooltip="uniToolTipTranslation('GO075', 'en-US')" class="materialSelectLabel">
              {{ uniTranslation("GO075") }}
            </label>
            <PheGeometryPicker :parent-path="parentPath" :local-path="localPath" no-label />
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12 col-lg-12">
            <label
              v-tooltip="uniToolTipTranslation('TRNSL217', 'en-US')"
              class="materialSelectLabel"
            >
              {{ uniTranslation("TRNSL217") }}
            </label>
            <PhePressurePicker
              :project-path="parentPath"
              :parent-path="path"
              :local-path="'.pressure'"
              no-label
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12 col-lg-12">
            <MaterialPicker
              :parent-path="path"
              :name="'.plateMaterial.id'"
              :tags="'.plateMaterial.tags'"
              :title="'TRNSL64'"
            />
          </div>
        </div>

        <div v-show="!isSaldobrasata" class="row">
          <div class="col-xl-12 col-lg-12">
            <MaterialPicker
              :parent-path="path"
              :name="'.gasketMaterial.id'"
              :tags="'.gasketMaterial.tags'"
              :title="'TRNSL66'"
            />
          </div>
        </div>
        <div v-show="!isSaldobrasata" class="row">
          <div class="col-xl-12 col-lg-12">
            <MaterialPicker
              :parent-path="path"
              :name="'.frameMaterial.id'"
              :tags="'.frameMaterial.tags'"
              :title="'TRNSL65'"
            />
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import PheGeometryPicker from "../shared/PheGeometryPicker";
import MaterialPicker from "../shared/MaterialPicker";
import PhePressurePicker from "../shared/PhePressurePicker.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    PheGeometryPicker,
    MaterialPicker,
    PhePressurePicker
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      pathPlateMaterial: null,
      pathGasketMaterial: null,
      pathFrameMaterial: null,
      isTypeOfPheVisible: true,
      isDesignStandardVisible: true,
      isProductLineVisible: true,
      coloreSfondo: "",
      coloreBarraTitolo: "",
      coloreTitolo: "",
      coloreTesto: "",
      coloreBordo: "",
      coloreFooterSfondo: "",
      coloreFooterTesto: "",
      coloreFooterBottoniSelection: "",
      coloreTestoBottoniSelection: "",
      coloreBordoBottoniSelection: "",
      coloreFooterBottoniVerify: "",
      coloreTestoBottoniVerify: "",
      coloreBordoBottoniVerify: "",
      dtml: ["DTMLFisso", "DTMLVariabile"],
      dtmlValue: 0
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["isSaldobrasata", "projects", "isVerifica", "isSelezione"]),
    ...mapGetters("_commonModule", ["isInManagement"]),
    ...mapGetters("_colorsModule", ["cardColors", "footerColors"]),
    modalitaExpert: function() {
      return this.$store.getters.modalitaExpert;
    },
    inSaldobrasata: function() {
      return this.isSaldobrasata;
    },
    inVerifica: function() {
      if (this.isVerifica) {
        this.setVerify();
      }

      return this.isVerifica;
    },
    inSelezione: function() {
      if (this.isSelezione) {
        this.setSelection();
      }

      return this.isSelezione;
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    cardColors() {
      this.setColors();
    },
    footerColors() {
      this.setColors();
    }
  },
  mounted: function() {
    var that = this;

    if (this.parentPath && this.localPath) {
      this.path = this.parentPath + this.localPath;
      this.pathPlateMaterial = this.path + ".plate";
      this.pathGasketMaterial = this.path + ".gasket";
      this.pathFrameMaterial = this.path + ".frame";
      that.setColors();
      if (that.isInManagement || that.isSelezione == false) {
        that.setSelection();
      }
    }
  },
  methods: {
    setColors() {
      var that = this;
      that.coloreSfondo = that.cardColors[0] + " !important"; // 4 elem: 0=sfondo 1=barra con titolo 2=testo 3=titolo
      that.coloreBarraTitolo = that.cardColors[1]; // 3 elem non usati + altri 2
      that.coloreTesto = that.cardColors[2];
      that.coloreTitolo = that.cardColors[3];
      that.coloreBordo = that.cardColors[6];
      that.coloriFooter = that.cardColors; // 3 elementi 0=sfondo 1=testo 2=bottoni

      that.coloreFooterSfondo = that.footerColors[0];
      that.coloreFooterTesto = that.footerColors[1];

      that.coloreFooterBottoniSelection = that.footerColors[2] + " !important";
      that.coloreTestoBottoniSelection = that.footerColors[3];
      that.coloreBordoBottoniSelection = that.footerColors[4];

      that.coloreFooterBottoniVerify = "white !important";
      that.coloreTestoBottoniVerify = that.footerColors[2] + " !important";
      that.coloreBordoBottoniVerify = that.footerColors[2] + " !important";
    },
    setSelection() {
      var that = this;
      that.coloreFooterBottoniSelection = that.footerColors[2] + " !important";
      that.coloreTestoBottoniSelection = that.footerColors[3];
      that.coloreBordoBottoniSelection = that.footerColors[4];

      that.coloreFooterBottoniVerify = "white !important";
      that.coloreTestoBottoniVerify = that.footerColors[2] + " !important";
      that.coloreBordoBottoniVerify = that.footerColors[2] + " !important";

      that.$emit("setSelection");
    },
    setVerify() {
      var that = this;
      that.coloreFooterBottoniVerify = that.footerColors[2] + " !important";
      that.coloreTestoBottoniVerify = that.footerColors[3];
      that.coloreBordoBottoniVerify = that.footerColors[4];

      that.coloreFooterBottoniSelection = "white !important";
      that.coloreTestoBottoniSelection = that.footerColors[2] + " !important";
      that.coloreBordoBottoniSelection = that.footerColors[2] + " !important";

      that.$emit("setVerify");
    }
  }
};
</script>

<style lang="scss">
.card .card-header {
  background-color: transparent;
  padding: 0px;
}

label {
  margin-bottom: 0px;
}

div {
  hr {
    margin-bottom: 10px;
    margin-top: 10px;
    border: solid;
    border-width: 1px;
    width: 90%;
    height: 0px;
    /* Set the hr color */
    color: #333; /* old IE */
    background-color: #333; /* Modern Browsers */
  }
}

.materialSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.materialSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px !important;
    }
  }
}
</style>
